import React from 'react';
import styled from 'styled-components/macro';

const ErrorBoundaryFallback = (): JSX.Element => {
  return (
    <ErrorMessageContainer>
      <ErrorHeadline>An internal server error has occurred.</ErrorHeadline>
      <ErrorMessage>
        An error has occurred while processing your request. The Televet support team has been notified of the problem.
        If you believe you have additional information that may be of help in reproducing or correcting the error,
        please contact TeleVet Support.
      </ErrorMessage>
    </ErrorMessageContainer>
  );
};

export default ErrorBoundaryFallback;

const ErrorMessageContainer = styled.div`
  margin: 0 auto;
  position: relative;
  text-align: center;
  top: 50%;
  transform: translateY(-50%);
  width: 60%;
`;

const ErrorHeadline = styled.h1`
  color: hsl(0, 0%, 70%);
  display: inline-block;
  font-size: 3rem;
  margin-bottom: 0.1em;
`;

const ErrorMessage = styled.p`
  color: hsl(0, 0%, 70%);
  display: inline-block;
  font-size: 1rem;
  text-align: left;
  width: 95%;
`;
